const VIEWPORT_GAP = 8;

// The panel this measures. LF360-1881 renamed it, and because the only test of
// this handed back a panel whatever it was asked for, nothing noticed: the
// selector stopped matching, no height was ever set, and a panel with a few
// reminders on it simply ran off the bottom of the screen.
export const ACTIVITY_PANEL_SELECTOR = ".activity-modal";

// Ant flips a dropdown above/below its trigger, but corner placements do not
// shrink tall content to the space on the chosen side. Keep the popup edge
// anchored to the activity and make only the panel body scrollable.
export const fitActivityDropdownToViewport = (popup, align) => {
  const panel = popup?.querySelector?.(ACTIVITY_PANEL_SELECTOR);
  if (!panel || typeof window === "undefined") return;

  const viewportHeight = window.visualViewport?.height || window.innerHeight;
  const popupRect = popup.getBoundingClientRect();
  const popupPoint = align?.points?.[0] || "";
  const opensAbove = popupPoint.startsWith("b");
  const availableHeight = opensAbove
    ? popupRect.bottom - VIEWPORT_GAP
    : viewportHeight - popupRect.top - VIEWPORT_GAP;

  panel.style.maxHeight = `${Math.max(0, Math.floor(availableHeight))}px`;
};
